import axios from 'axios';

// V3
export default {
	getSeonData(sessionId) {
		return axios.get(`/apps/seon/api/seon/${sessionId}`);
	}
};

// V5
const httpClient = axios.create({
	baseURL: '/apps/seon/api/seon/v5'
});

export const useSeonApi = (sessionId) => {
	const postSession = (sessionData) => httpClient.post(`/${sessionId}`, { seonData: sessionData });
	const getSession = () => httpClient.get(`/${sessionId}`);
	return {
		postSession,
		getSession
	};
};